export const SEASONS = [
    { key: 'AUTUMN', label: 'Autumn' },
    { key: 'AUTUMN_WINTER', label: 'Autumn/Winter' },
    { key: 'HOLIDAY', label: 'Holiday' },
    { key: 'PRE_AUTUMN', label: 'Pre-Autumn' },
    { key: 'PRE_SPRING', label: 'Pre-Spring' },
    { key: 'SEASONLESS', label: 'Seasonless' },
    { key: 'SPRING', label: 'Spring' },
    { key: 'SPRING_SUMMER', label: 'Spring/Summer' },
    { key: 'SUMMER', label: 'Summer' },
    { key: 'UNKNOWN', label: 'Unknown' },
    { key: 'WINTER', label: 'Winter' },
];